/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getBooleanDecoder,
  getBooleanEncoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type Collection = { verified: boolean; key: Address };

export type CollectionArgs = Collection;

export function getCollectionEncoder(): FixedSizeEncoder<CollectionArgs> {
  return getStructEncoder([
    ['verified', getBooleanEncoder()],
    ['key', getAddressEncoder()],
  ]);
}

export function getCollectionDecoder(): FixedSizeDecoder<Collection> {
  return getStructDecoder([
    ['verified', getBooleanDecoder()],
    ['key', getAddressDecoder()],
  ]);
}

export function getCollectionCodec(): FixedSizeCodec<
  CollectionArgs,
  Collection
> {
  return combineCodec(getCollectionEncoder(), getCollectionDecoder());
}
